<template>
  <v-content class="gb list-user">
    <v-container fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" md="12" class="top-container">
          <v-card
              :loading="status === 'loading' || status_action === 'loading'"
              class="fill-width table_theme card-theme custom-container"
          >
            <v-card-title class="title_table medium-font" style="letter-spacing: normal">
              Agents

              <v-progress-circular
                  v-if="status==='loading'"
                  indeterminate
                  color="primary"
                  style="padding: 0px 30px;"
              ></v-progress-circular>

              <v-spacer></v-spacer>
              <div
                  class="custom-o-search-bar"
              >
                <v-text-field
                    v-model="search"
                    placeholder="Search..."
                    single-line
                    hide-details
                    class="input_search"
                    color="#198beb"
                >
                  <img
                      :src="require('@/assets/img/search.svg')"
                      slot="prepend"
                      alt="help"
                      class="info-tooltip"
                  />
                </v-text-field>
              </div>
            </v-card-title>
            <v-divider class="ma-0 list-divider"></v-divider>
            <div class="status-stats-bar">
              <div class="status-stats-bar__item">
                <span class="status-stats-bar__label">Total</span>
                <span class="status-stats-bar__count">{{ statusCounts.reduce((s, i) => s + i.count, 0) }}</span>
              </div>
              <template v-if="user && user.user_role === 'super_user'">
                <div class="status-stats-bar__divider"></div>
                <div class="status-stats-bar__item" title="Unique people (deduped by owner_id) across tenants">
                  <span class="status-stats-bar__label">Unique</span>
                  <span class="status-stats-bar__count">{{ uniqueOwnerCount }}</span>
                </div>
              </template>
              <div v-if="statusCounts.length > 0" class="status-stats-bar__divider"></div>
              <template v-for="(item, index) in statusCounts">
                <div v-if="index > 0" :key="'divider-' + item.status" class="status-stats-bar__divider"></div>
                <div
                    :key="item.status"
                    class="status-stats-bar__item"
                    :class="{ 'status-stats-bar__item--active': filters.status === item.status }"
                    @click="toggleStatusFilter(item.status)"
                    style="cursor: pointer;"
                >
                  <v-icon class="status-stats-bar__dot" :style="{ color: statusColor(item.status) }">brightness_1</v-icon>
                  <span class="status-stats-bar__label">{{ item.status }}</span>
                  <span class="status-stats-bar__count">{{ item.count }}</span>
                </div>
              </template>
              <div class="status-stats-bar__actions">
                <v-btn v-if="paymentPermission" rounded text color="#29ABE2"
                    class="btn-blanco table_btn custom-o-white btn-border action-btn-width"
                    v-on:click="$router.push('/owner/users/add-users')"
                >Add New Agent</v-btn>
                <v-btn rounded text color="#29ABE2"
                    class="btn-blanco table_btn custom-o-white btn-border action-btn-width"
                    :disabled="allSelectedInactive"
                    @click="show_DeleteModal"
                >Delete & Transfer</v-btn>
                <v-btn v-if="paymentPermission" rounded text color="#29ABE2"
                    class="btn-blanco table_btn custom-o-white btn-border action-btn-width"
                    :disabled="allSelectedInactive"
                    @click="show_ResendModal"
                >Resend Invite</v-btn>
                <v-btn rounded text color="#29ABE2"
                    class="btn-blanco table_btn custom-o-white btn-border action-btn-width"
                    style="text-transform: none;"
                    :href="rutaExel + '&order_by='+ orderBy +'&sort_by='+ sort_by"
                    :disabled="selected.length === 0"
                >Download (excel)</v-btn>
              </div>
            </div>
            <template v-if="error">
              <div>
                <v-alert type="error" dense dismissible @input="error = false">{{ message_error }}</v-alert>
              </div>

            </template>
            <v-data-table
                v-model="selected"
                :headers="showHeaders"
                :items="filteredItems"
                :search="search"
                :custom-filter="searchFilter"
                color="#717e91"
                :multi-sort="false"
                item-key="id"
                show-select
                :options.sync="options"
                :custom-sort="customSort"
                class="agents-table"
                :mobile-breakpoint="0"
            >
              <template v-slot:header.data-table-select="{ props, on }">
                <SelectCheckbox
                    :value="props.value"
                    :indeterminate="props.indeterminate"
                    @input="on.input($event)"
                />
              </template>
              <template v-slot:item.data-table-select="{ isSelected, select }">
                <SelectCheckbox
                    :value="isSelected"
                    @input="select($event)"
                />
              </template>

              <template v-slot:no-data>
                <div style="padding: 24px; text-align: center; color: #717e91; font-size: 13px;">
                  <span v-if="deletedCount > 0 && filters.status !== 'Deleted'">{{ deletedCount }} deleted user(s) are hidden — click Deleted above to view.</span>
                  <span v-else>No users found.</span>
                </div>
              </template>


              <!-- buttons moved to status-stats-bar -->
              <template v-slot:item.company_name="{ item }" v-if="'T' == 'X'">
                <span :title=item.company_name>
                  {{ item.company_name }}
                </span>
              </template>
              <template v-slot:item.name="{ item }">
                <span :title="item.name" class="text-truncate-cell">
                  {{ item.name }}
                </span>
              </template>
              <template v-slot:item.email="{ item }">
                <span :title="item.email" class="text-truncate-cell">{{ item.email }}</span>
              </template>
              <template v-slot:item.phone="{ item }">
                <span>{{ item.phone }}</span>
              </template>
              <template v-slot:item.actions="{ item }">
                <v-btn
                    depressed
                    @click="openEditModal(item)"
                    style="padding: 0; font-size: 11px; height: 24px; min-width: 44px; color: #061D47; border: 1px solid #061D47;"
                >Edit
                </v-btn>
              </template>
              <template v-slot:item.status="{ item }">
                <span
                    class="text-xs-right table-f"
                    style="text-transform: capitalize; display: inline-block !important; font-size: 12px !important;"
                >
                  <v-icon
                      class="status-icon custom-status-icon"
                      v-bind:style="{
                      color: statusColor(item.status)
                    }"
                  >brightness_1</v-icon>
                  {{ item.status }}
                </span>
              </template>
              <template v-slot:item.created_at="{ item }">
                <span class="table-f" style="font-size: 12px !important;">{{ formatRegisteredDate(item.created_at) }}</span>
              </template>
              <template v-slot:item.url="{ item }">
                <div class="url-cell" v-if="item.url">
                  <v-menu open-on-hover top offset-y nudge-top="4" :close-on-content-click="false" :close-delay="200" content-class="url-menu">
                    <template v-slot:activator="{ on }">
                      <span v-on="on" class="url-preview" @click="copyURL(item)">
                        <img :src="require('@/assets/img/copy.svg')" alt="Copy URL"/>
                      </span>
                    </template>
                    <div class="url-menu-body" @click.stop>
                      <span class="url-menu-text">{{ item.url }}</span>
                    </div>
                  </v-menu>
                  <span v-if="item.copied" class="url-copied-label">Copied!</span>
                </div>
              </template>
              <template v-slot:item.notifications="{ item }">
                <div style="text-align: center;">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon small v-bind="attrs" v-on="on" :color="notificationStatusDisplay(item).color">
                        {{ notificationStatusDisplay(item).icon }}
                      </v-icon>
                    </template>
                    <span>{{ notificationStatusDisplay(item).label }}</span>
                  </v-tooltip>
                </div>
              </template>
              <template v-slot:item.activeClients="{ item }">
                <div style="text-align: center;">{{ item.activeClients }}</div>
              </template>
              <template v-slot:item.messagesReceived="{ item }">
                <div style="text-align: center;">{{ item.messagesReceived }}</div>
              </template>
              <template v-slot:item.messagesSent="{ item }">
                <div style="text-align: center;">{{ item.messagesSent }}</div>
              </template>
              <template v-slot:item.is_admin="{ item }">
                <div class="admin-cell">
                  <v-simple-checkbox
                      :value="item.is_admin"
                      @input="switch_admin(item)"
                      color="primary"
                      :ripple="false"
                  ></v-simple-checkbox>
                  <v-tooltip v-if="item.user_role === 'owner'" top content-class="compact-tooltip" nudge-top="-4">
                    <template v-slot:activator="{ on }">
                      <span v-on="on" class="admin-role-label">O</span>
                    </template>
                    <span>Owner</span>
                  </v-tooltip>
                </div>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
      <delete-modal
          :selected="selected"
          :show="showDeleteModal"
          :hide="hideDeleteModal"
          @setter="setter"
      />
      <DeleteAllModal
          :show="showDeleteAllModal"
          :hide="hideDeleteAllModal"
      />
      <resend-modal :show="showResendModal" :hide="hideResendModal" :results="resendResults"/>
      <edit-user-modal
          :show="showEditModal"
          :user="selectedUser"
          :hide="closeEditModal"
      />
    </v-container>
  </v-content>
</template>

<style scoped lang="scss">
  .modal-content {
    max-width: 530px;
  }

  .custom-select-margin {
    margin-top: -10px;
  }

  .url-cell {
    display: inline-flex;
    align-items: center;
    gap: 6px;
  }

  .url-preview {
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    padding: 4px;
  }

  .url-preview:hover {
    opacity: 0.7;
  }

  .url-copied-label {
    font-size: 11px;
    color: #4caf50;
    font-weight: 500;
  }
</style>

<script>
  import deleteModal from "./modals/delete";
  import DeleteAllModal from "@/views//modals/delete-all";
  import resendModal from "./modals/resend";
  import EditUserModal from "@/views/owner/modals/EditUserModal";
  import {mapState, mapActions} from "vuex";
  import config from "@/config/constants.js";
  import {mask} from "vue-the-mask";
  import PaymentMixin from '@/mixins/payment';
  import SelectCheckbox from '@/components/SelectCheckbox.vue';
  import {notificationStatusDisplay} from '@/util/notification_status';

  let token = localStorage.getItem("auth_token");
  export default {
    name: "usersList",
    mixins: [PaymentMixin],
    created() {
      this._isDestroyed = false;
      if (this.$store.getters["Authenticate/isLoggedIn"]) {
        const prevRole = this.$store.state.Users_list.userRole;
        if (prevRole && prevRole !== 'agent') {
          this.$store.dispatch('Users_list/clear_data');
        }
        this.$store.dispatch("Users_list/get_tenant", "agent").then(response => {
          if (this._isDestroyed) return;
          if (response === 'success') {
            this.get_users("agent");
          }
        });
      } else {
        this.$router.push("/owner/sign_up");
      }
    },
    directives: {
      mask,
    },
    computed: {
      ...mapState({
        status: (state) => state.Users_list.status,
        status_action: (state) => state.Users_list.status_action,
        totals: (state) => state.Users_list.totals,
        dataUsers: (state) => state.Users_list.dataUsers,
        dataCompanies: (state) => state.Users_list.dataCompanies,
        userAgentReferrals: (state) => state.Users_list.userAgentReferrals,
        user: (state) => state.Authenticate.user,
      }),
      selectedUser() {
        if (!this.selectedUserId) return {};
        return this.dataUsers.find(u => u.owner_id === this.selectedUserId) || {};
      },
      filteredItems() {
        const STATUS_ORDER = { active: 0, onboarding: 1, "signed up": 2, invited: 3, inactive: 4, cancelled: 5, deleted: 6 };
        let items = this.dataUsers;
        if (!this.filters.status) {
          items = items.filter(x => (x.status || '').toLowerCase() !== 'deleted');
        } else {
          items = items.filter(x => this.filters.status.toLowerCase() === (x.status || '').toLowerCase());
        }
        if (this.company_data && this.company_data.toLowerCase() !== 'all') {
          items = items.filter(x => (x.company_name || '').toLowerCase() === this.company_data.toLowerCase());
        }
        // Default sort by status (Active first) when no column sort is active
        if (!this.options.sortBy || this.options.sortBy.length === 0) {
          return [...items].sort((a, b) => {
            const aOrder = STATUS_ORDER[(a.status || "").toLowerCase()] ?? Infinity;
            const bOrder = STATUS_ORDER[(b.status || "").toLowerCase()] ?? Infinity;
            if (aOrder !== bOrder) return aOrder - bOrder;
            const aName = (a.name || "").toLowerCase();
            const bName = (b.name || "").toLowerCase();
            return aName < bName ? -1 : aName > bName ? 1 : 0;
          });
        }
        return items;
      },
      showHeaders() {

        const self = this;
        if (self.user.user_role === 'super_user') {
          self.selectedHeaders = ['COMPANY NAME', 'NAME', 'EMAIL', 'PHONE', 'STATUS', 'REGISTERED', 'URL', 'ALERTS', 'USERS', 'IN', 'OUT', 'ADMIN', 'ACTIONS'];
        } else {
          self.selectedHeaders = ['NAME', 'EMAIL', 'PHONE', 'STATUS', 'REGISTERED', 'URL', 'ALERTS', 'USERS', 'IN', 'OUT', 'ADMIN', 'ACTIONS'];
        }
        return self.headers.filter(s => self.selectedHeaders.includes(s.text));
      },
      statusCounts() {
        const PREFERRED_ORDER = ['Active', 'Invited', 'Deleted', 'Cancelled'];
        const counts = {};
        for (const user of this.dataUsers) {
          if (user.status) counts[user.status] = (counts[user.status] || 0) + 1;
        }
        const ordered = PREFERRED_ORDER.filter(s => counts[s]);
        const extra = Object.keys(counts).filter(s => !PREFERRED_ORDER.includes(s));
        return [...ordered, ...extra].map(s => ({ status: s, count: counts[s] }));
      },
      uniqueOwnerCount() {
        const ids = new Set();
        for (const u of this.dataUsers) {
          if (u.owner_id) ids.add(u.owner_id);
        }
        return ids.size;
      },
      allSelectedInactive() {
        return this.selected.length === 0 || this.selected.every(u => ['Deleted', 'Cancelled'].includes(u.status));
      },
      deletedCount() {
        return this.dataUsers.filter(u => (u.status || '').toLowerCase() === 'deleted').length;
      }
    },
    components: {
      "delete-modal": deleteModal,
      "resend-modal": resendModal,
      "edit-user-modal": EditUserModal,
      DeleteAllModal,
      SelectCheckbox
    },
    watch: {
      selected(val) {
        const self = this;
        let usersSize = self.dataUsers.length;
        if (val.length > 0) {
          if (val.length === usersSize) {
            self.rutaExel = config.api_url + "download_exel?user_role=agent&token=" + token + "&users=all";
          } else {
            let usersIds = val.map(function (user) {
              return user.owner_id;
            })
            self.rutaExel = config.api_url + "download_exel?user_role=agent&token=" + token + "&users=" + usersIds;
          }
        } else {
          self.rutaExel = config.api_url + "download_exel?user_role=agent&token=" + token;
        }
      }
    },
    data() {
      return {
        showDeleteAllModal: false,
        company_data: null,
        options: {
          itemsPerPage: 25,
          sortBy: [],
          sortDesc: []
        },
        selected: [],
        showDeleteModal: false,
        showResendModal: false,
        resendResults: [],
        types: ["User 1", "User 2"],
        search: "",
        filters: {
          status: ""
        },
        statuses: [
          {id: "", name: "All Users"},
          {id: "active", name: "Active Users"},
          {id: "invited", name: "Invited Users"},
          {id: "deleted", name: "Deleted Users"},
          {id: "cancelled", name: "Cancelled Users"},
        ],
        singleSelect: true,
        rutaExel:
          config.api_url +
          "download_exel?user_role=agent&token=" + token,
        headers: [
          {text: "COMPANY NAME", value: "company_name", sortable: true},
          {text: "NAME", value: "name", sortable: true},
          {text: "EMAIL", value: "email", sortable: true},
          {text: "PHONE", value: "phone", sortable: true, width: '150px'},
          {text: "STATUS", value: "status", sortable: true, width: '90px'},
          {text: "REGISTERED", value: "created_at", sortable: true, width: '90px'},
          {text: "URL", value: "url", sortable: true, width: '48px'},
          {text: "ALERTS", value: "notifications", sortable: true, width: '65px', align: 'center', cellClass: 'col-center'},
          {text: "USERS", value: "activeClients", sortable: true, width: '65px', align: 'center', cellClass: 'col-center'},
          {text: "IN", value: "messagesReceived", sortable: true, width: '50px', align: 'center', cellClass: 'col-center'},
          {text: "OUT", value: "messagesSent", sortable: true, width: '50px', align: 'center', cellClass: 'col-center'},
          {text: "ADMIN", value: "is_admin", sortable: true, width: '65px', align: 'center', cellClass: 'col-center'},
          {text: "ACTIONS", value: "actions", sortable: false, width: '70px', align: 'center', cellClass: 'col-center'},
        ],
        selectedHeaders: [],
        orderBy: null,
        sortBy: null,
        showEditModal: false,
        selectedUserId: null,
      };
    },
    filters: {
      //
    },
    methods: {
      notificationStatusDisplay,
      ...mapActions({
        get_users: "Users_list/get_users",
      }),
      searchFilter(value, search, item) {
        if (!search) return true;
        const s = search.toLowerCase();
        const str = [item.company_name, item.name, item.email, item.phone, item.status].filter(Boolean).join(' ').toLowerCase();
        return str.includes(s);
      },
      toggleStatusFilter(status) {
        this.filters.status = this.filters.status === status ? "" : status;
      },
      formatRegisteredDate(timestamp) {
        if (!timestamp) return '';
        const d = new Date(timestamp);
        const m = d.getMonth() + 1;
        const day = String(d.getDate()).padStart(2, '0');
        const y = String(d.getFullYear()).slice(-2);
        return `${m}/${day}/${y}`;
      },
      statusColor(status) {
        let color = "";
        switch (status) {
          case "Active": {
            color = "#12d120";
            break;
          }
          case "Invited":
          case "Deleted":
          case "Cancelled":
          case "Onboarding":
          case "Inactive": {
            color = "#717e91";
            break;
          }
        }
        return color;
      },
      copyURL(item) {
        if (!item.url) return;
        navigator.clipboard.writeText(item.url).then(() => {
          this.$set(item, 'copied', true);
          setTimeout(() => {
            this.$set(item, 'copied', false);
          }, 1500);
        });
      },
      setter() {
        const self = this;
        self.selected = [];
      },
      show_DeleteModal() {
        if (this.selected.length === this.dataUsers.length) {
          this.showDeleteAllModal = true;
        } else {
          this.showDeleteModal = true;
        }
      },
      hideDeleteAllModal() {
        this.showDeleteAllModal = false;
      },
      hideDeleteModal() {
        this.showDeleteModal = false;
      },
      show_ResendModal() {
        const self = this;
        self.$store
          .dispatch("Users_list/resend_invite", {
            users: self.selected,
            type: ""
          })
          .then(results => {
            self.resendResults = Array.isArray(results) ? results : [];
            self.showResendModal = true;
          });
      },
      hideResendModal() {
        this.showResendModal = false;
      },
      switch_admin(user) {
        const self = this;
        self.$store.dispatch("Users_list/switch_admin", user).then(() => {

        });
      },
      customSort(items, index, isDescending) {
        this.orderBy = index[0];
        this.sort_by = (isDescending[0]) ? 'desc' : 'asc';

        const STATUS_ORDER = { active: 0, onboarding: 1, "signed up": 2, invited: 3, inactive: 4, cancelled: 5, deleted: 6 };

        // Firestore Timestamps stringify to "[object Object]"; route them through
        // their numeric ms value so the first sort click actually orders them.
        const toMillisOrNull = (v) => {
          if (v == null) return null;
          if (typeof v.toMillis === 'function') return v.toMillis();
          if (v instanceof Date) return v.getTime();
          if (typeof v === 'object' && typeof v.seconds === 'number') return v.seconds * 1000 + Math.floor((v.nanoseconds || 0) / 1e6);
          return null;
        };

        return items.sort((a, b) => {
          const col = index[0];
          if (col === "status") {
            const aOrder = STATUS_ORDER[(a.status || "").toLowerCase()] ?? Infinity;
            const bOrder = STATUS_ORDER[(b.status || "").toLowerCase()] ?? Infinity;
            if (aOrder !== bOrder) return isDescending[0] ? aOrder - bOrder : bOrder - aOrder;
            const aCompany = (a.company_name || "").toLowerCase();
            const bCompany = (b.company_name || "").toLowerCase();
            if (aCompany !== bCompany) return aCompany < bCompany ? -1 : 1;
            const aName = (a.name || "").toLowerCase();
            const bName = (b.name || "").toLowerCase();
            return aName < bName ? -1 : aName > bName ? 1 : 0;
          }
          // Generic sort for all other columns
          let aVal = a[col] ?? '';
          let bVal = b[col] ?? '';
          // Date / Firestore Timestamp comparison — convert to milliseconds.
          // Without this, Firestore Timestamps stringify to "[object Object]"
          // and the first sort click is meaningless.
          const aMs = toMillisOrNull(aVal);
          const bMs = toMillisOrNull(bVal);
          if (aMs !== null || bMs !== null) {
            const aN = aMs ?? -Infinity;
            const bN = bMs ?? -Infinity;
            if (aN === bN) return 0;
            return isDescending[0] ? (aN < bN ? 1 : -1) : (aN < bN ? -1 : 1);
          }
          // Numeric comparison for number fields
          if (typeof aVal === 'number' || typeof bVal === 'number') {
            aVal = Number(aVal) || 0;
            bVal = Number(bVal) || 0;
          } else {
            aVal = String(aVal).toLowerCase();
            bVal = String(bVal).toLowerCase();
          }
          if (aVal === bVal) return 0;
          if (isDescending[0]) {
            return aVal < bVal ? 1 : -1;
          } else {
            return aVal < bVal ? -1 : 1;
          }
        });
      },
      openEditModal(item) {
        this.selectedUserId = item.owner_id;
        this.showEditModal = true;
      },
      closeEditModal() {
        this.showEditModal = false;
      },
      editItem(item) {
        const self = this;
        self.openEditModal(item);
      },
      saveItem(item) {
        const self = this;
        let new_phone_number = document.querySelector("#value_" + item.owner_id).value.replaceAll(' ', '').replaceAll('-', '');
        if (item.phone !== new_phone_number) {
          self.$store.dispatch("Users_list/update_phone_number", {
            new_phone_number: new_phone_number,
            phone_number: item.phone,
            owner_id: item.owner_id
          })
            .then((errorsCounter) => {
              if (errorsCounter !== null) {
                self.phone_selected = null;
                self.owner_selected = null;
              } else {
                self.phone_selected = null;
                self.owner_selected = null;
                self.$store.dispatch('Users_list/clear_data');
                self.$store.dispatch("Users_list/get_tenant", "agent").then(response => {
                  if (response === 'success') {
                    this.get_users("agent");
                  }
                });
              }
            }).catch(error => {
            console.error(error);
          });
        } else {
          self.phone_selected = null;
          self.owner_selected = null;
        }
      },
      cancelItem() {
        const self = this;
        self.phone_selected = null;
        self.owner_selected = null;
      },
    },
    beforeDestroy() {
      this._isDestroyed = true;
    }
  };
</script>

<style scoped lang="scss">
  .status-stats-bar {
    display: flex;
    align-items: center;
    padding: 8px 16px;
    margin-bottom: 8px;
    background-color: #f8f9fb;
    border-bottom: 1px solid #e8ebef;

    &__divider {
      width: 1px;
      height: 16px;
      background-color: #d0d5dd;
      margin: 0 16px;
      flex-shrink: 0;
    }

    &__item {
      display: flex;
      align-items: center;
      gap: 5px;
    }

    &__item--active {
      background: #E3F2FD;
      border-radius: 6px;
      padding: 2px 8px;
    }

    &__dot {
      font-size: 7px !important;
    }

    &__label {
      color: #717e91;
      font-size: 12px;
      font-weight: 500;
    }

    &__count {
      color: #29ABE2;
      font-size: 12px;
      font-weight: 600;
    }

    &__actions {
      margin-left: auto;
      display: flex;
      align-items: center;
      gap: 8px;
    }
  }

  .list-user {
    .top-container {
      margin-top: 0px;
    }

    .chk .v-input__slot {
      justify-content: flex-start !important;
    }

    .mar_table {
      margin: 0 5px !important;
    }

    .list-divider {
      max-width: 1096px;
      margin-left: 13px !important;
    }

    .custom-container {
      max-width: 1222px !important;
      min-height: 558px;
      margin-bottom: 50px !important;
    }

    .custom-o-white {
      height: 32px !important;
      top: 2px;
    }

    .action-btn-width {
      width: 149px;
    }

    .table_btn {
      color: #2bace2;
      font-size: 13px;
      font-weight: 400;
      text-transform: capitalize;
      letter-spacing: normal;
    }

    .table_botonera {
      padding: 15px 16px 20px;
      position: relative;
    }

    .fill-width .mar_table {
      margin: 0 13px;
    }

    .input_field_phone_number {
      padding: 0;
    }
  }

  .admin-cell {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }
  .admin-role-label {
    position: absolute;
    left: calc(50% + 14px);
    font-size: 11px;
    font-weight: 600;
    color: #979797;
    cursor: default;
  }

  /* ---- Responsive ---- */
  @media (max-width: 1100px) {
    .status-stats-bar {
      flex-wrap: wrap;
      gap: 6px 12px;
      padding: 8px 12px;

      &__divider { display: none; }

      &__actions {
        width: 100%;
        margin-left: 0;
        margin-top: 8px;
        flex-wrap: wrap;
        gap: 6px;
      }
    }

    .list-user .action-btn-width {
      width: auto;
      min-width: 0;
      flex: 1 1 0;
    }
  }

  @media (max-width: 768px) {
    .list-user .custom-container {
      min-height: auto;
      margin-bottom: 20px !important;
    }
  }

  @media (max-width: 600px) {
    .status-stats-bar {
      padding: 6px 8px;
      gap: 4px 8px;

      &__label { font-size: 11px; }
      &__count { font-size: 11px; }

      &__actions {
        gap: 4px;

        .v-btn {
          width: auto !important;
          min-width: 0 !important;
          font-size: 10px !important;
          padding: 0 6px !important;
          height: 26px !important;
          letter-spacing: 0 !important;
        }
      }
    }
  }
</style>

<!-- Clean table styles — replaces old global nth-child rules -->
<style lang="scss">
  .agents-table {
    /* Footer */
    .v-data-footer { border-top: none !important; }

    table {
      margin: 0 auto;
      max-width: 1096px;
      table-layout: fixed;
      width: 100%;
    }

    /* Header row */
    thead tr th {
      height: 48px !important;
      font-size: 11px !important;
      font-weight: 700 !important;
      text-transform: uppercase;
      font-family: Roboto, sans-serif !important;
      color: #979797 !important;
      white-space: nowrap;
      border-bottom: none !important;
      padding: 0 8px !important;

      /* Sort icon — hidden by default, visible only on active sort column */
      .v-data-table-header__icon {
        color: #29ABE2 !important;
        margin-left: 2px;
        font-size: 14px !important;
        opacity: 0 !important;
        display: inline-block !important;
        vertical-align: middle;
      }

      &.active .v-data-table-header__icon {
        opacity: 1 !important;
      }

      /* Header text span — reset global overrides */
      span {
        position: static !important;
        top: auto !important;
        padding-right: 0 !important;
        line-height: normal !important;
        display: inline !important;
      }
    }

    /* Data rows */
    tbody tr {
      box-shadow: inset 0 1px 0 rgba(0,0,0,0.08) !important;

      td {
        height: 48px !important;
        font-size: 13px;
        font-weight: 400;
        padding: 0 8px !important;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;

      }
    }

    /* Centered columns */
    th.text-center {
      text-align: center !important;
    }
    td.col-center {
      text-align: center !important;
      overflow: visible !important;
    }

    /* Checkbox column */
    th:first-child, td:first-child {
      width: 48px !important;
      max-width: 48px !important;
    }
  }

  .text-truncate-cell {
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .v-tooltip__content.compact-tooltip {
    background: #333 !important;
    color: #fff !important;
    border-radius: 4px !important;
    font-size: 11px !important;
    font-weight: 500 !important;
    padding: 4px 8px !important;
    min-height: auto !important;
    min-width: auto !important;
    line-height: 1.3 !important;
    box-shadow: 0 2px 8px rgba(0,0,0,0.15) !important;
    opacity: 0.95 !important;
  }

  .url-menu {
    background: #fff !important;
    border: 1px solid #e0e0e0 !important;
    border-radius: 6px !important;
    box-shadow: 0 2px 8px rgba(0,0,0,0.12) !important;
    min-width: 0 !important;
    max-width: 320px !important;
    padding: 0 !important;
  }

  .url-menu-body {
    padding: 6px 10px;
  }

  .url-menu-text {
    font-size: 12px;
    color: #333;
    user-select: text;
    cursor: text;
    word-break: break-all;
    white-space: normal;
    line-height: 1.4;
    display: block;
  }

  /* ---- Responsive table ---- */
  @media (max-width: 1100px) {
    .agents-table {
      .v-data-table__wrapper {
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;
      }

      table {
        table-layout: auto !important;
        min-width: 900px;
      }
    }

    .v-card__title.title_table {
      flex-wrap: wrap;
      gap: 8px;
      padding: 16px !important;

      .v-spacer { flex: 0 0 0 !important; }
    }

    .custom-o-search-bar {
      position: relative !important;
      right: 0 !important;
      left: 0 !important;
    }
  }

  @media (max-width: 600px) {
    .v-card__title.title_table {
      flex-direction: column;
      align-items: flex-start !important;

      .v-spacer { display: none; }
    }

    .custom-o-search-bar {
      width: 100% !important;
      max-width: 300px !important;
    }

    .agents-table table {
      min-width: 750px;
    }
  }
</style>
